<gds-spacer classes="spacer-120"></gds-spacer>

@switch (currentStep()) {
  @case ('step-1') {
    <app-verify-your-identity-step-1
      [email]="email()"
      [guestId]="guestId()"
      (emailCodeSelected)="showStep2($event)"
      (limitReached)="showLimitReached()"
    ></app-verify-your-identity-step-1>
  }
  @case ('step-2') {
    <app-verify-your-identity-step-2
      [challenge]="otpChallenge()"
      (submitted)="showComplete()"
      (limitReached)="showLimitReached()"
      (verifyFailed)="onVerifyFailed($event)"
      (challengeReplaced)="replaceChallenge($event)"
    ></app-verify-your-identity-step-2>
  }
  @case ('limit-reached') {
    <app-verify-your-identity-limit-reached
      (canceled)="cancel()"
    ></app-verify-your-identity-limit-reached>
  }
}
